const MAX_LOGS = 200;
const STORAGE_KEY = 'slot_tvde_error_log';

const getStoredLogs = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
};

const saveLogs = (logs) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(logs.slice(-MAX_LOGS)));
  } catch {
    // localStorage full - trim aggressively
    localStorage.setItem(STORAGE_KEY, JSON.stringify(logs.slice(-50)));
  }
};

export const logEvent = (type, details) => {
  const logs = getStoredLogs();
  logs.push({
    ts: new Date().toISOString(),
    type,
    ...details,
  });
  saveLogs(logs);
};

export const getLogs = () => getStoredLogs();

export const clearLogs = () => {
  localStorage.removeItem(STORAGE_KEY);
};

export const getLogStats = () => {
  const logs = getStoredLogs();
  const stats = { total: logs.length, byType: {}, byStatus: {}, last401: null };
  logs.forEach((l) => {
    stats.byType[l.type] = (stats.byType[l.type] || 0) + 1;
    if (l.status) stats.byStatus[l.status] = (stats.byStatus[l.status] || 0) + 1;
    if (l.status === 401) stats.last401 = l.ts;
  });
  return stats;
};
